import Http from '@/api/http_v2.js'

export default {
  index(params) {
    return Http.get(`/product_prices`, { params })
  },
  update(data) {
    return Http.put(`/product_prices/${data.id}`, data)
  },
}
